import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCTISSchema } from "./CTISSchemaProvider";
import CTISDynamicFormRenderer from "./CTISDynamicFormRenderer";
// ADDED 'Badge' to the import list to fix the undefined error
import { Spinner, Alert, Container, Badge } from "react-bootstrap";

export default function CTISTemplateRendererPage() {
  const { templateId } = useParams();
  const { loadTemplate, activeTemplate } = useCTISSchema();
  const [localLoading, setLocalLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchTemplate = async () => {
      // Guard: Don't re-fetch if this template is already the active one
      if (activeTemplate?.screen_id === templateId) {
        setLocalLoading(false);
        return;
      }

      setLocalLoading(true);
      try {
        const data = await loadTemplate(templateId);
        if (!data && isMounted) {
          setError(`Template ${templateId} not found in EMA Blueprint.`);
        }
      } catch (err) {
        if (isMounted) setError("Failed to parse template DNA.");
      } finally {
        if (isMounted) setLocalLoading(false);
      }
    };

    fetchTemplate();

    return () => { isMounted = false; };
    
    // Suppressing dependency warning to prevent infinite fetch loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId, loadTemplate]); 

  if (localLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" variant="dark" />
        <p className="mt-3 text-muted">Decoding EMA Template DNA...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Container className="mt-4">
        <Alert variant="danger" className="border-0 shadow-sm">
          <Alert.Heading>Structure Error</Alert.Heading>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <div className="animate-fade-in px-2">
      <div className="mb-4 border-bottom pb-3">
        {/* Badge is now correctly defined */}
        <Badge bg="dark" className="mb-2 text-uppercase">EMA Standard Screen</Badge>
        <h1 className="h3 fw-bold text-dark">
          {activeTemplate?.template_metadata?.official_sheet_name || templateId}
        </h1>
        <p className="text-muted mb-0">
          Source Reference: <span className="text-monospace small">{activeTemplate?.template_metadata?.source_file || "Dynamic"}</span>
        </p>
      </div>
      
      {/* Dynamic Form Engine */}
      <CTISDynamicFormRenderer 
        template={activeTemplate} 
        formData={{}} 
        onFieldChange={(id, val) => console.log(`Field Update: ${id} ->`, val)} 
      />
    </div>
  );
}